
            const fs = {
              readFileSync: () => '',
              writeFileSync: () => {},
              existsSync: () => false,
              close: function () {},
              open: function () {},
            };

            Object.defineProperties(fs, {
              close: {
                value: function () {},
                writable: true,
                configurable: true
              }
            });

            module.exports = fs;
          